import React from 'react'
import { Fade } from 'react-awesome-reveal'
import Scrollbtn from '../button/Scrollbtn';
import ColorTheme from '../theme/ColorTheme';

function Footer() {

    const handleSubmit = (e) => {
        e.preventDefault()
    }

    return (
        <>
            <Scrollbtn />
            <footer>
                <div className="zx-footer">
                    <div className="container">
                        <div className="row padding-tb-100">
                            <Fade className="col-lg-3 col-md-6 col-sm-12 footer-lg" triggerOnce duration={500} direction='up'>
                                <>
                                    <ul className="footer-main">
                                        <li>
                                            <h4>
                                                <img src="assets/img/logo/logo-footer.png" alt="logo" />
                                            </h4>
                                        </li>
                                        <li>
                                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting. standard dummy text ever since the 1500s.</p>
                                        </li>
                                    </ul>
                                </>
                            </Fade>
                            <Fade className="col-lg-3 col-md-6 col-sm-12 footer-lg" triggerOnce duration={1000} direction='up'>
                                <>
                                    <ul className="footer-main">
                                        <li>
                                            <h4>Working hours</h4>
                                        </li>
                                        <li className="zx-footer-link zx-ped">
                                            <a onClick={handleSubmit} href="/">Mon - Fri: 9:00AM - 5:00PM</a>
                                        </li>
                                        <li className="zx-footer-link zx-ped">
                                            <a onClick={handleSubmit} href="/">Saturday - Fri: 9:00AM - 5:00PM</a>
                                        </li>
                                        <li className="zx-footer-link zx-ped">
                                            <a onClick={handleSubmit} href="/">Sunday : closed</a>
                                        </li>
                                    </ul>
                                </>
                            </Fade>
                            <Fade className="col-lg-3 col-md-6 col-sm-12 footer-lg" triggerOnce duration={1500} direction='up'>
                                <>
                                    <ul className="footer-main">
                                        <li>
                                            <h4>Contacts Us</h4>
                                        </li>
                                        <li>
                                            <p>
                                                5 Green St.Huntington consectetur blue stati on, NY 11746
                                            </p>
                                        </li>
                                        <li className="zx-footer-link">
                                            <h6>
                                                <a onClick={handleSubmit} href="/">+examle@ec-email.com</a>
                                            </h6>
                                        </li>
                                        <li className="zx-footer-link">
                                            <h6>
                                                <a onClick={handleSubmit} href="/">+91 (123) (4567) (890)</a>
                                            </h6>
                                        </li>
                                    </ul>
                                </>
                            </Fade>
                            <Fade triggerOnce duration={2000} direction='up' className="col-lg-3 col-md-6 col-sm-12 footer-lg">
                                <>
                                    <ul className="footer-main">
                                        <li>
                                            <h4>Subscribe</h4>
                                        </li>
                                        <li>
                                            <form onClick={handleSubmit} action="/" className="subscribe d-flex">
                                                <input type="text" name="search" placeholder="Search" required="" />
                                                <button className="result-placeholder">
                                                    <span className="fa fa-paper-plane" aria-hidden="true"></span>
                                                </button>
                                            </form>
                                        </li>
                                        <li>
                                            <a onClick={handleSubmit} href="/"><img src="assets/img/logo/facebook.png" alt="facebook" /></a>
                                            <a onClick={handleSubmit} href="/"><img src="assets/img/logo/twitter.png" alt="twitter" /></a>
                                            <a onClick={handleSubmit} href="/"><img src="assets/img/logo/instagram.png" alt="instagram" /></a>
                                            <a onClick={handleSubmit} href="/"><img src="assets/img/logo/linkedin.png" alt="linkedin" /></a>
                                        </li>
                                    </ul>
                                </>
                            </Fade>
                        </div>
                        <div className="row">
                            <div className="col-12 bordered">
                                <div className="last-footer">
                                    <p>
                                        copyright  @  <a onClick={handleSubmit} href="/"><span className="text-color"> Zorox </span></a>
                                        all rights reserved.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            <ColorTheme />

        </>
    )
}

export default Footer
